module.exports = __webpack_public_path__ + "static/media/Content-adaptation-illustration.de960283.svg";